module.exports = __webpack_public_path__ + "img/plane_enemy3.a21aa39a.png";